
import React from 'react'
import { connect } from 'react-redux'
import { Radio } from 'semantic-ui-react'

const RadioOnly = (props) => {

    const {
        input,
        label,
        disabled,
        require,
        options,
        specialOnChange,
        halfRow = false,
        meta: { touched, error }
    } = props

    return (


        <div className={`flex items-center `}>
            {
                options?.map((o,i) =>
                    <Radio
                        key={i}
                        name={input.name}
                        disabled={disabled}
                        label={o.text}
                        value={o.value}
                        checked={input.value === o.value}
                        onChange={() => {
                            input.onChange(o.value)
                            if (specialOnChange) specialOnChange(o.value)
                        }}
                        style={{ marginLeft: '1rem' }}
                    />
                )
            }

        </div>





    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(RadioOnly)